import { TReconnectConfig } from '../../types/reconnection-config';

import { UberConferenceServiceComponent } from './UberConferenceServiceComponent';

export const UberconferenceReconnectionConfig: TReconnectConfig = {
  serviceComponent: UberConferenceServiceComponent,
};
